/**
 * @file Warns the user with a native browser prompt before they leave the page.
 */
import React, { useEffect } from "react";

type Props = {
  children: React.ReactNode;
};

/**
 * Renders its children and asks the browser to confirm before the tab or
 * page is closed or navigated away from.
 */
const BeforeUnload = ({
  children,
}: Props): JSX.Element => {
  useEffect(() => {
    /**
     * Blocks the default unload action so the browser shows its prompt.
     */
    const listener = (event: BeforeUnloadEvent) => {
      event.preventDefault();

      if (event.defaultPrevented) {
        event.returnValue = "";
        return event.returnValue;
      }
    };

    window.addEventListener("beforeunload", listener);

    return () => {
      window.removeEventListener("beforeunload", listener);
    };
  }, []);

  return (
    <>
      {children}
    </>
  );
};

export default BeforeUnload;
